import { useTranslation } from 'react-i18next';

import { EsimsSearchForm } from '@frontend/features/travel-services/components/EsimsSearchForm';
import { TravelServicesPage } from '@frontend/features/travel-services/components/TravelServicesPage';
import { useSearchFormKey } from '@frontend/features/travel-services/useSearchUrlState';

/** Buscador de eSIMs (vertical esims de Rutero). */
export const Esims = () => {
  const { t } = useTranslation();
  // Aplicar una búsqueda reciente remonta el buscador: si no, los campos
  // (que se llenan al montar) quedarían vacíos bajo los resultados nuevos.
  const formKey = useSearchFormKey();

  return (
    <TravelServicesPage
      title={t('common.nav.esims')}
      intro={t('travelServices.esimsIntro')}
    >
      <EsimsSearchForm key={formKey} />
    </TravelServicesPage>
  );
};

export default Esims;
